<template>
    <div id="app">
        <RouterView />
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    watch: {
        "$store.state.keepAlive.list"(val) {
            // process.env.NODE_ENV == "development" &&
            // console.log(`[ keepAliveList ] ${val}`);
        },
        "$store.state.settings.mode": {
            handler() {
                if (this.$store.state.settings.mode == "pc") {
                    this.$store.commit("settings/updateThemeSetting", {
                        sidebarCollapse: this.$store.state.settings.sidebarCollapseLastStatus,
                    });
                } else if (this.$store.state.settings.mode == "mobile") {
                    this.$store.commit("settings/updateThemeSetting", {
                        sidebarCollapse: true,
                    });
                }
                document.body.setAttribute("data-mode", this.$store.state.settings.mode);
            },
            immediate: true,
        },
    },
    mounted() {
        if (this.$store.state.user.token) {
            this.checkDeadToken();
        }
        window.onresize = () => {
            this.$store.commit("settings/setMode", document.body.clientWidth);
        };
        window.onresize();
    },
    methods: {
        getParams() {
            // var url = window.location.search;

            var url = decodeURIComponent(location.href);
            // console.log(location);
            var obj = {};
            if (url.indexOf("?") != -1) {
                var arr = url.split("?");
                var strS = arr[1].split("&");
                for (var i = 0; i < strS.length; i++) {
                    obj[strS[i].split("=")[0]] = strS[i].split("=")[1];
                }
            }
            return obj;
        },
        checkDeadToken() {
            let deadTokenTime = JSON.parse(localStorage.getItem("deadTokenTime"));
            if (deadTokenTime) {
                if (Number(new Date()) + 10 * 3600 * 1000 > deadTokenTime) {
                    this.$notify.error({
                        title: "登录过期",
                        message: "登陆已过期，请重新登陆",
                    });
                    this.$store.dispatch("user/logout").then(() => {
                        this.$router.push({
                            name: "login",
                        });
                    });
                }
            }
            // 若不是单点登录并且不是管理员
            else if (!Object.keys(this.getParams()).includes("appKey") && localStorage.getItem("userinfo")) {
                this.$store.dispatch("user/logout").then(() => {
                    this.$router.push({
                        name: "login",
                    });
                });
            }
        },
    },
    metaInfo() {
        return {
            title: this.$store.state.settings.enableDynamicTitle && this.$store.state.settings.title,
            titleTemplate: (title) => {
                return title != "404" ? `${title} - ${process.env.VUE_APP_TITLE}` : process.env.VUE_APP_TITLE;
            },
        };
    },
};
</script>

<style lang="scss">
.center_all {
    display: flex;
    justify-content: center;
    align-items: center;
}

// @font-face {
//   font-family: pf;
//   src: url('./assets/font/pf_z_j.ttf');
// }

.ace_editor {
    position: relative;
    overflow: hidden;
    font:
        12px / normal "Monaco",
        "Menlo",
        "Ubuntu Mono",
        "Consolas",
        "source-code-pro",
        monospace;
    direction: ltr;
    text-align: left;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

// .ace_editor,.ace_editor *{
//     font-family:"Microsoft YaHei", "微软雅黑" !important ;
// }
#app {
    height: 100%;
    font-family: "pf", "Microsoft YaHei", "微软雅黑", sans-serif;
}

#home {
    height: 98.14814814vh;
    background: url("../src/assets/images/overview/main_bg.png") no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
}

.anchorBL {
    display: none !important;
}

.nav_bar .el-tabs__header {
    margin: 0 !important;
}

.nav_bar {
    .el-tabs {
        transform: translateY(7px);
    }

    .el-tabs--card > .el-tabs__header .el-tabs__item:first-child .el-icon-close {
        display: none;
    }

    .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
        // border-bottom: none;
        background: #f1f4fd;
        border-bottom: none !important;
        border-radius: 3px 3px 0 0 !important;
        box-sizing: border-box !important;
    }

    .el-tabs--card > .el-tabs__header .el-tabs__item.is-active:hover {
        // border-bottom: none;
        background: #f1f4fd;
    }

    .el-tabs--card > .el-tabs__header {
        border-bottom: none;
    }

    .el-tabs__nav {
        // border-top: none !important;
        border: none !important;
    }

    .el-tabs__nav-next,
    .el-tabs__nav-prev {
        i {
            color: #333333;
            font-size: 20px;
        }
    }

    .el-tabs__nav-prev {
        margin-left: -5px;
    }

    .el-tabs__nav-next {
        margin-right: -5px;
    }

    .el-tabs--card > .el-tabs__header .el-tabs__item:hover {
        background: rgb(222, 225, 230);
    }

    .el-tabs__item {
        // border-top: 4px solid #5482ee;
        position: relative;
        overflow: hidden;
        font-size: 14px !important;
        border-radius: 8px 8px 0 0;
    }

    .el-tabs__item.is-active::before {
        content: "";
        position: absolute;
        height: 3px;
        background: #0c6fff;
        width: 100%;
        left: 0;
        top: 0;
    }
}

.readonly_wrap {
    .el-input__inner {
        color: #676a6c !important;
        font-weight: bold;
    }

    .el-select__caret.el-input__icon.el-icon-arrow-up {
        display: none;
    }

    .el-select__tags {
        .el-select__tags-text {
            color: #676a6c !important;
            font-weight: bold;
        }
    }

    .el-radio-group {
        .el-radio__label {
            color: #676a6c !important;
            font-weight: bold;
        }

        .el-radio__input.is-disabled.is-checked .el-radio__inner::after {
            background-color: #676a6c;
        }
    }

    .el-textarea__inner {
        color: #676a6c !important;
        font-weight: bold;
    }
}

// .vxe-checkbox .vxe-checkbox--label,
// .vxe-radio-button .vxe-radio--label,
// .vxe-radio .vxe-radio--label,
// .vxe-table--render-default
//   .vxe-body--column.col--ellipsis:not(.col--actived)
//   > .vxe-cell,
// .vxe-table--render-default
//   .vxe-footer--column.col--ellipsis:not(.col--actived)
//   > .vxe-cell,
// .vxe-table--render-default
//   .vxe-header--column.col--ellipsis:not(.col--actived)
//   > .vxe-cell {
//   height: 100% !important;
//   & > div {
//     max-width: 100%;
//   }
// }
// .vxe-checkbox .vxe-checkbox--label,
// .vxe-radio-button .vxe-radio--label,
// .vxe-radio .vxe-radio--label,
// .vxe-table--render-default
//   .vxe-body--column.col--ellipsis:not(.col--actived)
//   > .vxe-cell,
// .vxe-table--render-default
//   .vxe-footer--column.col--ellipsis:not(.col--actived)
//   > .vxe-cell,
// .vxe-table--render-default
//   .vxe-header--column.col--ellipsis:not(.col--actived)
//   > .vxe-cell {
//   display: flex;
//   align-items: center;
//   justify-content: center;
// }
// .vxe-cell .vxe-cell--checkbox,
// .vxe-cell .vxe-cell--radio {
//   transform: translateY(-10px);
// }
</style>
<style lang="scss">
//  @import "../assets/style/mixin.scss"
@import "./assets/css/reset.css";
// @import "./assets/css/pub.css";
// @import "./assets/css/table.scss";

//
// @font-face {
//   font-family: SourceHanSans;
//   src: url('./assets/font/SourceHanSansCN-Regular.otf');
// }

#app {
    height: 100%;
    font-family: "Microsoft YaHei", "微软雅黑", sans-serif;
    //   font-family: 'SourceHanSans', 'Microsoft YaHei', '微软雅黑', sans-serif;
    overflow-x: hidden;
    width: 100vw;
}

// th .vxe-cell {
//   margin-top: 13px !important;
// }
// td .vxe-cell {
//   margin-top: 7px !important;
// }
.anchorBL {
    display: none !important;
}

.nav_bar .el-tabs__header {
    margin: 0 !important;
}

.my_upload {
    .el-upload-list {
        display: block !important;
    }
}

.nav_bar {
    .el-tabs,
    .el-tabs__item {
        height: 50px;
        line-height: 50px;
        font-size: 18px;
        color: #999999;
    }

    .el-tabs--card > .el-tabs__header .el-tabs__item:first-child .el-icon-close {
        display: none;
    }

    .el-tabs--card > .el-tabs__header .el-tabs__item.is-active:hover,
    .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
        background: #f2f5fd;
        color: #28287d;
        font-weight: 600;
    }

    .el-tabs--card > .el-tabs__header {
        border-bottom: none;
    }

    .el-tabs__nav {
        // border-top: none !important;
        border: none !important;
    }

    .el-tabs__nav-next,
    .el-tabs__nav-prev {
        i {
            color: #333333;
            font-size: 20px;
        }
    }

    .el-tabs__nav-prev {
        margin-left: -5px;
    }

    .el-tabs__nav-next {
        margin-right: -5px;
    }

    .el-tabs--card > .el-tabs__header .el-tabs__item:hover {
        background: rgb(222, 225, 230);
    }

    .el-tabs__item {
        // border-top: 4px solid #5482ee;
        position: relative;
        overflow: hidden;
        border-radius: 8px 8px 0 0;
    }

    .el-tabs__item.is-active::before {
        content: "";
        position: absolute;
        height: 3px;
        background: #0c6fff;

        border-radius: 3px 3px 0px 0px;
        width: 100%;
        left: 0;
        top: 0;
    }
}

.order-button {
    line-height: 24px;
}

.query_wrap {
    display: flex;
    align-items: center;
    align-self: start;
    flex-wrap: wrap;
    // background-color: #f4f5f7;
    // border: 1px solid #ccc;
    padding-left: 5px;
    padding-right: 5px;
    box-sizing: border-box;
    border-radius: 4px;
    margin: 10px 0;

    .query_item {
        display: flex;
        align-items: center;
        padding: 5px 10px;

        .my_inp {
            width: 100%;
        }

        .lab {
            // color: #5faeff;
            // font-weight: bold;
            padding-right: 3px;
            flex: 0 0 90px;
            font-size: 14px;
            color: #333333;
        }

        .con {
            flex: 1;
            display: flex;
            justify-content: space-between;

            .my_btn {
                width: 48%;
                margin-right: 0;
            }
        }
    }

    .w_25 {
        width: 25% !important;

        .query_btn {
            width: 100%;
        }
    }

    .w_33 {
        width: 33% !important;

        .query_btn {
            width: 100%;
        }
    }

    .w_50 {
        width: 50% !important;

        .query_btn {
            width: 50%;
        }
    }

    .w_100 {
        width: 100% !important;

        .query_btn {
            width: 25%;
        }
    }

    .query_btn {
        display: flex;

        .my_btn {
            width: 100%;
        }
    }
}

.query_btn_wrap {
    .my_btn {
        width: www(95);
        height: hhh(40);
    }
}

.el-form-item {
    .el-select {
        width: 100%;
    }

    .cus-check-item {
        padding: 0 26px;
        height: 40px;
        background: #ffffff;
        border: 1px solid #d6d6d6;
        color: #999999;
        border-radius: 5px;
        display: inline-block;
        margin-right: 29px;
        line-height: 38px;
        cursor: pointer;
    }

    .cus-check-item.active {
        color: #169bd5;
        border-color: #169bd5;
    }
}

.edit-tab {
    th {
        background: #169bd5;

        color: #ffffff;
        height: 46px;
        padding: 0;
    }
}

.img-30 {
    width: 30px;
    height: 30px;
    display: inline-block;
}

.color-success {
    color: #21c376;
}

.color-waring {
    color: #ff9a00;
}

.color-danger {
    color: #fa2600;
}

.curd-btn-wrap {
    display: flex;
    justify-content: space-around;
}

.depart-wrap {
    .el-tree-node__label,
    .el-tree-node__content {
        letter-spacing: 1px;
    }

    .el-tree-node__content {
        height: hhh(46);
    }

    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
        height: hhh(46);
        line-height: hhh(46);
        font-size: 16px;
    }

    .departs::before,
    .positions::before {
        content: "";
        display: inline-block;
        width: hhh(30);
        height: hhh(30);
        flex: 0 0 hhh(30);
        background-size: 100% 100%;
        margin-right: 4px;
    }

    .departs::before {
        background-image: url("./assets/images/departNew.png");
        // width: 16px;
        background-size: 16px 16px;
        background-repeat: no-repeat;
        background-position: 2px 6px;
    }

    .positions::before {
        background-image: url("./assets/images/position.png");
        // componty
        // position
        background-size: 16px 16px;
        background-repeat: no-repeat;
        background-position: 2px 6px;
    }

    .el-tree-node__content:hover,
    .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
        background-color: #ecf2fa;
        color: #0c6fff;

        // .departs::before {
        //   background-image: url("./assets/images/departs-b.png");
        // }

        // .positions::before {
        //   background-image: url("./assets/images/position-b.png");
        // }
    }
}

.btn {
    height: 40px;
    border-radius: 5px;
    border: 1px solid #d6d6d6;
    display: inline-block;
    line-height: 38px;
    text-align: center;
    cursor: pointer;
    color: #333333;
    padding: 0 24px;
    margin-right: 17px;
    font-size: 16px;
}

.blue-btn {
    height: 40px;
    background: #0c6fff;
    border-radius: 5px;
    color: white;

    i {
        margin-right: 6px;
        font-size: 18px;
    }
}

.red-w-btn {
    color: #fa2600;
    border-color: #fa2600;
}

.form-msg {
    color: #aaaaaa;
    line-height: 20px;
}

.box-search-wrap {
    background: #ffffff;
    box-shadow: 0px 0px 18px 0px rgba(45, 83, 218, 0.08);
    border-radius: 10px;
    padding: 5px 10px;
}

.box-tab-wrap {
    background: #ffffff;
    box-shadow: 0px 0px 18px 0px rgba(45, 83, 218, 0.08);
    border-radius: 10px;
    margin-top: 10px;
    padding: 14px 20px 6px 20px;
}

.main-form {
    background: #ffffff;
    box-shadow: 0px 0px 18px 0px rgba(45, 83, 218, 0.08);
    border-radius: 10px;
    width: 100%;
    margin: 0 auto 15px auto;
    padding: 0 www(25) hhh(56) www(25);

    .form-head-title {
        margin: 0 www(-25) 0 www(-25);
        padding: hhh(35) www(42) hhh(29) www(40);
        font-size: 18px;
        // font-weight: bold;
        color: #333333;
        border-bottom: 1px solid #f2f2f2;
    }

    .form-title {
        padding: hhh(47) 0 hhh(38) www(15);
        font-size: 18px;
        font-weight: bold;
        color: #333333;
    }

    .regist-title {
        padding: hhh(47) 0 0 www(15);
        font-size: 18px;
        font-weight: bold;
        color: #333333;
    }

    .form {
        margin: 0 www(44);
    }
}

.foot {
    justify-content: center;
    padding: hhh(38) 0;

    .el-button {
        width: www(160);
    }
}

.main-wrap {
    padding: 10px 0px 0 20px;
    box-shadow: 0px 0px 18px 0px rgb(45 83 218 / 8%);
    background: white;
    border-radius: 10px;
}

.flex {
    display: flex;
}

.flex-wrap {
    display: flex;
    flex-wrap: wrap;
}

.el-image-viewer__wrapper {
    z-index: 20000 !important;
}

.tab-over-ellipsis .table_wrap .cell {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.flex-align-center {
    display: flex;
    align-items: center;
}

.vxe-modal--box .el-form-item__error {
    top: auto;
    bottom: -20px;
    padding-top: 0;
}

.cursor {
    cursor: pointer;
}

.flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.three-col,
.two-col {
    display: flex;
    white-space: nowrap;
    align-items: center;
    justify-content: space-between;
}

.two-col > div {
    flex: 0 0 40%;
}

.three-col > div {
    flex: 0 0 30%;
}

.box-tab-wrap.weblist_wrap {
    padding: 10px 20px;
}

.sub-sidebar-container {
    .el-menu-item {
        height: 45px;
        // margin-top: 20px;
        line-height: 45px;
    }
}

.color-icon {
    &::before {
        content: "";
        width: 10px;
        height: 10px;
        background: gray;
        border-radius: 50%;
        display: inline-block;
        margin-right: 14px;
    }

    &.bag-success::before {
        background: #21c376;
    }

    &.bag-danger::before {
        background: #fa2600;
    }
}

.bag-info {
    color: lightgray;
}

.bag-success {
    color: #21c376;
}

.bag-waring {
    color: #ff9a00;
}

.bag-danger {
    color: #fa2600;
}

.is-active {
}

.box-tab-wrap.weblist_wrap {
    .el-tabs__nav-scroll {
        padding-left: www(27);
    }

    .el-tabs {
        .el-tabs__nav {
            width: 100%;
        }

        .el-tabs__item {
            height: hhh(80);
            line-height: hhh(80);
            font-weight: 500;
            letter-spacing: 1px;
            font-size: 18px;

            &.is-active {
                color: #0c6fff;
                font-weight: 600;
            }
        }

        .el-tabs__active-bar {
            background-color: #0c6fff;
        }

        .el-tabs__item.is-disabled {
            // div[aria-controls='pane-addBtnWrap'] {
            // .tab-add-wrap {
            position: absolute;
            right: 0;
            display: flex;
            align-items: center;
            top: 0;

            .my_btn {
                width: www(95);
                height: hhh(40);
            }
        }
    }
}

.table_wrap {
    padding-top: hhh(37);
}

.el-button.el-button--primary {
    background: #0c6fff;
}

.cus-per {
    background-color: #1257ab !important; //rgba(0, 72, 188, 0.5);
    border: 1px solid #1393ff !important;

    .el-select-dropdown__item.selected {
        background-color: #1257ab;
        color: #409eff;
        font-weight: 700;
    }

    .el-select-dropdown__item {
        color: white;
    }

    .el-select-dropdown__item.hover,
    .el-select-dropdown__item:hover {
        background-color: #1257ab;
        color: #fff;
    }
}

.full {
    // border: 1px solid red;
    position: absolute;
    right: 40px;
    top: 5px;
    z-index: 100;
    width: 25px;
    height: 25px;
    background-image: url("./assets/videoImage/full.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
    cursor: pointer;
}

.close {
    // border: 1px solid red;
    position: absolute;
    right: 5px;
    top: 5px;
    z-index: 22;
    width: 25px;
    height: 25px;
    background-image: url("./assets/videoImage/close.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
    cursor: pointer;
}

.arrow {
    width: hhh(50);
    height: hhh(50);
    position: absolute;
    transform-origin: center center;
    background-image: url("./assets/videoImage/ctl.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    cursor: pointer;

    &:active {
        background-image: url("./assets/videoImage/check.png");
    }
}

.banquan {
    // position: absolute;
    // bottom: 30px;
    transform: translateY(10px);
    width: 100%;
    margin: 0;
    color: #999999;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
}
.color-green {
    color: #21c376;
    border-radius: 2px;
    border: 1px solid #21c376;
}

.color-orange {
    color: #ff9a00;
    border-radius: 2px;
    border: 1px solid #ff9a00;
}

.color-red {
    color: #fa2600;
    border-radius: 2px;
    border: 1px solid #fa2600;
}
.color-blue {
    color: #63abfd;
    border-radius: 2px;
    border: 1px solid #63abfd;
}
.color-purple {
    color: #7948ea;
    border-radius: 2px;
    border: 1px solid #7948ea;
}
.color-pink {
    color: #ac33c1;
    border-radius: 2px;
    border: 1px solid #ac33c1;
}

.el-picker-panel__body-wrapper {
    .el-picker-panel__icon-btn {
        font-weight: 700 !important;
    }
}

.flex-mian {
    //   display: flex;
    //   flex-direction: column;
    //   .box-search-wrap {
    //     height: 50%;
    //   }
    //   .box-tab-wrap {
    //     height: 50% !important;
    //   }
    //   //   height: 100%;
    //   //   height: calc(100% - 200px);
}

.split-title {
    font-size: 14px;
    font-weight: 700;
    font-weight: bold;
    color: #333333;
    display: flex;
    align-items: center;
    margin-top: 12px;
    margin-bottom: 10px;
    height: 24px;
    // background-color: rgba(250, 250, 250, 1);

    &::before {
        content: "";
        display: block;
        width: 4px;
        flex: 0 0 4px;
        height: 16px;
        background: #166df1;
        margin-right: 5px;
        border-radius: 0px 4px 4px 0px;
    }
}

.flex-end {
    display: flex;
    justify-content: flex-end;
}
</style>
